import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import { useAgencyAuthStore } from '../../stores/agencyAuthStore';
import { trpc } from '../../lib/api';
import { isAuthError } from './authGuardUtils';

interface AgencyAuthGuardProps {
  children: React.ReactNode;
}

export function AgencyAuthGuard({ children }: AgencyAuthGuardProps) {
  const location = useLocation();
  const { isAuthenticated, clearAuth, token } = useAgencyAuthStore();

  const { isLoading, error } = trpc.agencyAuth.me.useQuery(
    { token: token || '' },
    {
      enabled: isAuthenticated && !!token,
      retry: false,
    }
  );

  useEffect(() => {
    if (error && isAuthError(error)) {
      // Token might be expired or invalid
      clearAuth();
    }
  }, [error, clearAuth]);

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!isAuthenticated || !token) {
    // Redirect to agency login page but save the attempted location
    return <Navigate to="/agency/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
